import { useEffect } from 'react';
import { useRouter } from 'next/router';

// Routes
import { ANALYZE_OVERVIEW } from '@/routes/privateRoutes';

// Types
import type { NotificationAnalyticsProps } from '@/utils/hooks/context/toast/types';
import type { SocialProfileType } from '@/types/socialProfileType';

// Hooks
import useActiveSocialProfile from '@/utils/hooks/user/useActiveSocialProfile';
import useSelectedSocialProfileById from '@/utils/hooks/socialprofiles/useSelectedSocialProfileById';

// Component
import Notification from '@/components/base/Notification';

const FirstStatsReady = ({ notification }: NotificationAnalyticsProps) => {
    const router = useRouter();
    const { setActiveSocialProfile } = useActiveSocialProfile();
    const { selectedSocialProfile } = useSelectedSocialProfileById(
        notification?.data?.social_profile_id as SocialProfileType['id']
    );

    // Prefetch Overview
    useEffect(() => {
        router.prefetch(ANALYZE_OVERVIEW);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Notification
            dataNotification={notification}
            onClick={() => {
                if (selectedSocialProfile) {
                    setActiveSocialProfile(selectedSocialProfile);
                    router.push(ANALYZE_OVERVIEW);
                }
            }}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Avatar socialProfile={selectedSocialProfile} />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.first_stats_ready.title" />
                <Notification.Description
                    i18nKey="commons:notifications.first_stats_ready.description"
                    values={{
                        social_network: notification?.data?.social_network,
                        username: notification?.data?.social_user_name
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default FirstStatsReady;
